import React from 'react';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';
import BoxWrapper from 'components/atoms/BoxWrapper';
import Grid from '@material-ui/core/Grid';
import CustomTypography from 'components/atoms/CustomTypography';
import Container from '@material-ui/core/Container';
import { routes } from 'routes/Routes';
import LinkButton from 'components/atoms/LinkButton';

const PageNotFound = () => {
    return (
        <>
            <HeaderTemplate title="Page Not Found" />
            <Container>
                <BoxWrapper mt="50">
                    <Grid container justify="center">
                        <Grid item xs={12} md={6}>
                            <CustomTypography align="center" variant="h2" fontSize="10" customfont>
                                404
                            </CustomTypography>
                            <CustomTypography align="center" variant="h2" fontSize="4" customfont>
                                Page not found
                            </CustomTypography>
                            <BoxWrapper mt="25">
                                <LinkButton width="50" to={routes.homeRoute}>
                                    Back to Home Page
                                </LinkButton>
                            </BoxWrapper>
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </Container>
        </>
    );
};

export default PageNotFound;
